var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Close Fill",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM4.8743 4.09098L7 6.21669L9.12571 4.09098L9.91667 4.88194L7.79096 7.00765L9.91667 9.13335L9.12571 9.92431L7 7.79861L4.8743 9.92431L4.08334 9.13335L6.20904 7.00765L4.08334 4.88194L4.8743 4.09098Z",
    fill: "#0051BA",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFill);
export default __webpack_public_path__ + "static/media/close_fill.8b943e8afb38acb93207caa9dcd3fd08.svg";
export { ForwardRef as ReactComponent };